import { Locale } from "models/locale";
import { enTranslations } from "translations/en";
import { fiTranslations } from "translations/fi";
import { svTranslations } from "translations/sv";

export const getTranslations = (locale: Locale) => {
  switch (locale) {
    case "fi":
      return fiTranslations;
    case "sv":
      return svTranslations;
    case "en":
    default:
      return enTranslations;
  }
};
